import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { CONNECTIONTYPES } from '../../../../constants/applicationConstants';
import {
  DataTableHoc,
  Loader,
  ErrorFallback,
  deleteFilter,
  applyFilter,
  saveFilters,
} from 'smart-react';
import { GridColumnsList } from '../Components/Filter/FilterElements';
import DataColumns from '../Components/DataColumns/DataColumns';
import {
  ROW_LAYOUTS,
  PAGE_SIZE,
} from '../../../../constants/applicationConstants';
const BaseDataTable = React.lazy(
  () => import('../Components/DataTable/DataTable'),
);
const ConnectionTypeDataTable = DataTableHoc(BaseDataTable);

/**
 * Connection Type main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Connection Type component.
 */
const ConnectionType = ({ systemType }) => {
  const [userData, setUserData] = React.useState([]);
  const dataColumnsArray = DataColumns({});
  // used to check API is ready to call
  const [isReady, setIsReady] = React.useState(false);

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='container mx-auto k-px-4'>
        <React.Suspense fallback={<Loader />}>
          <ConnectionTypeDataTable
            deleteFilter={deleteFilter}
            applyFilter={applyFilter}
            saveFilters={saveFilters}
            moduleName={CONNECTIONTYPES}
            dataColumns={dataColumnsArray}
            gridColumnsList={GridColumnsList}
            dataTableName={CONNECTIONTYPES}
            setIsReady={setIsReady}
            isReady={isReady}
            rowLayoutConfigName={`${CONNECTIONTYPES}.DataGrid.RowLayout`}
            pageLengthConfigName={`${CONNECTIONTYPES}.DataGrid.ItemsPerPage`}
            dataSet={userData}
            setDataSet={setUserData}
            isCardonMobileView={false}
            total={process.env.DefaultLimit}
            defaultRowLayout={process.env.RowLayout}
            rowLayouts={ROW_LAYOUTS}
            pageSizes={PAGE_SIZE}
            isDefaultSlider={true}
            contentSliderTitle={'Connection Type'}
            systemType={systemType}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default ConnectionType;
